// removed by extract-text-webpack-plugin
module.exports = {"selectWrapper":"ZbchzumLJeV5Vn-z8f5LZ","selectLabel":"_21a0pBsGFk7Ts3YrwNgD-u","selectBase":"_2i9ry-XdQSqLqV-4EKK5DU","danger":"Yhomcts0BKEWow1I0YnTC"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/features/Input/Input.styl
// module id = 741
// module chunks = 0